import { FolderIcon } from "../../Icons/gui-elements-icons";

const FileSelectorButton = (props: {
  children: string | undefined;
  onClickFunction: () => void;
  id?: string;
  disabled?: boolean;
}) => {
  return (
    <button
      disabled={props.disabled}
      id={props.id ?? undefined}
      type="button"
      style={{
        userSelect: "none",
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        lineHeight: "1.2rem",
        margin: 0,
      }}
      onClick={() => props.onClickFunction()}
    >
      <span
        style={{
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "left",
          userSelect: "none",
        }}
      >
        {props.children}
      </span>
      <FolderIcon fill={"#fff"} />
    </button>
  );
};

export default FileSelectorButton;
